import confetti from "canvas-confetti";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

export const celebrate = () => {
  confetti({
    particleCount: 90,
    spread: 75,
    origin: { y: 0.7 },
    colors: ["#064E3B", "#D97706", "#FDFBF7", "#E7E0D2"],
  });
};

export const checkAchievements = async () => {
  try {
    const r = await api.get("/achievements");
    const fresh = r.data.filter((a) => a.new);
    if (fresh.length) {
      celebrate();
      fresh.forEach((a) =>
        toast.success(`Achievement unlocked: ${a.title}!`, { duration: 6000 })
      );
    }
    return r.data;
  } catch {
    return [];
  }
};
